import $ from 'jquery';

// import 'select2';                       // globally assign select2 fn to $ element
// import 'select2/dist/css/select2.css';  // optional if you have css loader

import '../postgrid';
import {getFilterAction} from "../postgrid";


let $eventLog, $eventSelect;

// function log(name, evt) {
//     if (!evt) {
//         var args = "{}";
//     } else {
//         var args = JSON.stringify(evt.params, function (key, value) {
//             if (value && value.nodeName) return "[DOM node]";
//             if (value instanceof $.Event) return "[$.Event]";
//             return value;
//         });
//     }
//     var $e = $("<li>" + name + " -> " + args + "</li>");
//     $eventLog.append($e);
//     $e.animate({opacity: 1}, 10000, 'linear', function () {
//         $e.animate({opacity: 0}, 2000, 'linear', function () {
//             $e.remove();
//         });
//     });
// }


function initSelect2() {


    // $eventLog = $(".publisher-log");

    $(document).ready(function () {

        // $eventSelect = $(".publisher-vendors__select2--select");

        $(".publisher-vendors__select2--select").select2({
            // placeholder: 'Select an option',
            // theme: 'classic',
            //
            closeOnSelect: false,
            placeholder: {
                id: -1, // the value of the option
                text: 'Select an option',
            },
            // theme: 'classic',
            width: '100%',
            minimumResultsForSearch: Infinity,
            // ajax: {
            //     url: "http://example.org/api/test",
            //     cache: false,
            // },


            // ajax:ajax {
            // url: "http://example.org/api/test",
            // cache: false,
            // },


            // debug: true,
            // matcher: false,
            // results: function (data) {
            //     return {
            //         results: data
            //     }
            // }
            // selectionAdapter: "SingleSelection",


            // allowClear: true,


        });
        //



        // var data = {
        //     id: 'all',
        //     text: 'View all',
        // };
        //
        // var newOption = new Option(data.text, data.id, false, false);
        // $('.publisher-vendors__select2--select').prepend(newOption).trigger('change');



        // $eventSelect.on("select2:open", function (e) {
        //     log("select2:open", e);
        // });
        // $eventSelect.on("select2:close", function (e) {
        //     log("select2:close", e);
        // });
        $(".publisher-vendors__select2--select").on("select2:select", function (e) {
            //console.log("select2:select", e);

            // getFilterAction(e.params.data, 'reload');
            getFilterAction(e.params.data.id, 'update_terms');

        });
        // $eventSelect.on("select2:unselect", function (e) {
        //     log("select2:unselect", e);
        // });
        //
        // $eventSelect.on("change", function (e) {
        //     log("change");
        // });


    });


}

export default initSelect2;
